// Language codes that ship with build-time precomputed translations in
// precomputed-translations.json. Kept as a tiny standalone list so the UI
// can decide which languages switch instantly WITHOUT pulling the ~945 KB
// JSON into the initial bundle (it is loaded lazily on first use).
// Keep in sync with the JSON's top-level keys (produced by
// scripts/pretranslate.mjs).
export const PRECOMPUTED_LANGS = ['fr', 'es', 'zh-CN']
